import { useState, useEffect } from "react";

const getStorageValue = (key, defaultValue) => {
  if (typeof window !== "undefined") {
    const saved = localStorage.getItem(key);

    return JSON.parse(saved) || defaultValue;
  }
};

const useLocalStorage = (key, defaultValue) => {
  const [value, setValue] = useState(getStorageValue(key, defaultValue));

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
};

export default useLocalStorage;
